import { useStateMachine } from 'little-state-machine';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import NavigationButtonGroup from '../../../../admin/Events/Steps/components/NavigationButtonGroup';
import EducationLevel from './EducationLevel';
import updateAction from './updateAction';

function IndividualStep1() {
  const { id, edit: isEdit } = useParams();
  const { actions } = useStateMachine({ updateAction });
  const { state } = useStateMachine({ updateAction });
  const rosterData = useSelector((state) => state.rosters.rosters);

  const [addMore, setAddMore] = useState(1);

  const [elementList, setElementList] = useState([]);

  const [defaultQualification, setDefaultQualification] = useState([]);

  const location = useLocation();
  useEffect(() => {
    if (isEdit) {
      if (rosterData && Array.isArray(rosterData?.user?.qualification)) {
        setAddMore(rosterData.user.qualification.length);
        setElementList(
          Array.from({ length: rosterData.user.qualification.length - 1 }, (v, i) => i + 2)
        );
        setDefaultQualification(rosterData.user.qualification);

        rosterData.user.qualification.forEach((qualification, index) => {
          setValue(`education[${index + 1}][educational_Level]`, {
            id: qualification.id,
            label: qualification.level,
            value: qualification.level
          });
          setValue(`education[${index + 1}][qualified_year]`, {
            label: qualification.final_year,
            value: qualification.final_year
          });
          setValue(`education[${index + 1}][faculty]`, {
            label: qualification.sector,
            value: qualification.sector
          });
          setValue(`education[${index + 1}][secured_grade]`, {
            label: qualification.grade,
            value: qualification.grade
          });
        });
      }
    }
  }, [rosterData]);

  useEffect(() => {
    if (state.education && Array.isArray(state?.education)) {
      setAddMore(state.education.length);
      setElementList(Array.from({ length: state.education.length - 1 }, (v, i) => i + 2));
      setDefaultQualification(state.education);

      state.education.forEach((qualification, index) => {
        setDefaultQualification(state.education);

        setValue(`education[${index + 1}][educational_Level]`, qualification.educational_Level);
        setValue(`education[${index + 1}][qualified_year]`, qualification.qualified_year);
        setValue(`education[${index + 1}][faculty]`, qualification.faculty);
        setValue(`education[${index + 1}][secured_grade]`, qualification.secured_grade);
      });
    }
  }, []);
  const handleAddMore = () => {
    setAddMore(addMore + 1);

    setElementList(elementList.concat(addMore + 1));
  };

  const handleRemove = (count) => {
    unregister(`education[${count}]`);
    const tempElementList = [...elementList];
    setElementList(tempElementList.filter((element) => element !== count));
  };

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    unregister,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {}
  });

  const onSubmit = (data) => {
    data = data.education.filter((element) => {
      if (Object.keys(element).length !== 0) {
        return true;
      }

      return false;
    });

    data = { education: data };
    actions.updateAction(data);

    let path = location.pathname.split('/');

    if (isEdit) {
      navigate(`/admin/rosters/individual/${id}/edit/2`);
    } else {
      path.includes('admin')
        ? navigate('/admin/rosters/individual_apply/2')
        : navigate('/rosters/individual_apply/2');
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h5 className="mt-4">
        <FormattedMessage id="qualification" />
      </h5>

      <div>
        <div className="px-2">
          <EducationLevel
            register={register}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            count={1}
            id={1}
            handleRemove={handleRemove}
            defaultValues={defaultQualification[0] || {}}
          />
          <div>
            {elementList.map((element, index) => {
              return (
                <div key={element}>
                  <EducationLevel
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    count={index + 2}
                    id={element}
                    handleRemove={handleRemove}
                    defaultValues={defaultQualification[index + 1] || {}}
                  />
                </div>
              );
            })}
          </div>
        </div>
        <div className="px-2">
          <Button variant="outline-primary mt-3 " onClick={handleAddMore}>
            <FormattedMessage id="add_more" />
          </Button>
        </div>

        <div className="">
          <hr />
          <NavigationButtonGroup
            backTo={isEdit ? '/admin/rosters/individual_list' : ''}
            // showSubmit={id}
          />
        </div>
      </div>
    </form>
  );
}

export default IndividualStep1;
